import { writable, readable } from "svelte/store";

export let origin;
export let local;
if (window.location.hostname == "topdent2.cure-plan.local") {
	origin = "http://server.cure-plan.local/";
	local = true;
} else {
	origin = "https://topdent.ru/";
	local = false;
}

export let isMobile = writable();
export let isWideScreen = writable();
export let isMenuClosed = writable();
export let isSublistClosed = writable();
export let isNewDataChanged = writable();

export let noNeedSendButton = writable();

export let isMenuHeaderDataNeeded = writable();

export let userEntity = writable();
export let menuEntity = writable();

export let clinicsNum = writable();

export let currentHash = writable();
export let lastHash = writable();
export let currentEntityID = writable();

export let dataChanged = writable();

export let daDataCheck = writable();

export let saved = writable();
export let changed = writable();
export let SpecialistPremodDone = writable();
export let specialistsIDs = writable([]);
export let specialistsAddArr = writable([]);
export let was_item_deleted_or_created = writable();

export let imageSize = readable(2097152);
export let imageNotifyError = readable("Размер изображения не должен превышать 2 МБ.");